<template>
  <div>
    <v-data-table
        dense
        :headers="columns"
        :items="price_amount_list"
        item-key="id"
        class="elevation-1"
        :sort-by="['amount']"
        hide-default-footer
        hide-default-header
        height="300"
    >
      <template v-slot:item.action="{ item }">
        <BaseDeleteDialog :item="item" :onDeleteAction="onDelete"></BaseDeleteDialog>
      </template>
      <template v-slot:item.amount="{ item }">
        <v-text-field
            class="mt-4"
            dense
            type="Number"
            v-model="item.amount"
            filled
            @change="onChange"
        >
        </v-text-field>
      </template>
      <template v-slot:item.price="{ item }">
        <v-text-field
            class="mt-4"
            dense
            type="Number"
            v-model="item.price"
            filled
            @change="onChange"
        >
        </v-text-field>
      </template>
      <template v-slot:footer>
        <v-spacer></v-spacer>
        <v-btn
            @click="onAdd"
        >
          Add
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>


<script>

import {mapGetters, mapActions} from "vuex";
import BaseDeleteDialog from "@/components/BaseDeleteDialog";

export default {
  name: 'BrandComponentPrices',
  props: ['prices'],

  components: {
    BaseDeleteDialog
  },

  computed: {
  },

  methods: {
    onDelete(item) {
      this.price_amount_list = this.price_amount_list.filter(row => row.id !== item.id)
    },
    onAdd() {
      this.price_amount_list.push({id: this.price_amount_list.length, price: '', amount: ''})
    },
    onChange(item) {
      let prices = {}
      for (const row of this.price_amount_list) {
        console.log('row', row)
        prices[row.amount] = row.price
      }
      this.$emit('update:prices', prices)
      console.log('prices', prices, this.price_amount_list)
    }
  },

  async mounted() {
    this.price_amount_list = []
        let id = 0
        for (const [amount, price] of Object.entries(this.prices)) {
          this.price_amount_list.push({id: id, price: price, amount: amount})
          id += 1
        }
  }
  ,

  data() {
    return {
      price_amount_list: [],
      columns: [
        {text: 'Amount', value: 'amount', sortable: false, filterable: false, divider: true},
        {text: 'Price', value: 'price', sortable: false, filterable: false, divider: true},
        {text: '', value: 'action', sortable: false, filterable: false, divider: true},
      ]
    }
  }
  ,
}

</script>


<style scoped lang="scss">
</style>